<script>
    import EmailIcon from "@propublica/pp-v5-shared/src/icons/mail.svg";
    import ArrowRightIcon from "@propublica/pp-v5-shared/src/icons/arrow-right--filled.svg";
    import Button from "../Button";
    import NewsletterInit, {
        newsletterSignupNumber,
    } from "../NewsletterInit.svelte";
    import RecaptchaInit from "../RecaptchaInit.svelte";

    // TODO(@alecglassford): Remove this prop and set the email input ID based
    //      on `placement` prop
    //      (e.g. `newsletter-signup-email-input-{placement}`)
    /** Unique id per usage of this component.
     * @type {string}
     */
    export let inputID;

    export let placeholderText = "Enter your email";

    /** @type {string | null} */
    export let borderStyle = null;

    export let newsletterList = "The Big Story";

    // TODO(@alecglassford): Make this prop required (breaking?)
    /** Used for tracking. This gets passed to Sailthru to help us identify
     * which specific form a newsletter signup came through. It can any unique
     * string that uniquely identifies where on the page the newsletter signup
     * form appears; for example, `"mid-story"` or `"end-of-story"`
     * @type {string | null}
     */
    export let placement = null;

    /** Story’s unit/region.
     * @type {( 'national' | 'electionland' | 'local' | 'local-reporting-network' | 'illinois' | 'texas' )}
     */
    export let region = "national";

    /**
     * Usually the subdomain. If set to `"https://www.propublica.org/"`, then
     * the component does not load recaptcha-related scripts; the assumption is
     * that on www, recaptcha is set up separately (not using Svelte).
     * @type {( 'https://projects.propublica.org/' | 'https://www.propublica.org/' )}
     */
    export let source = "https://projects.propublica.org/";
</script>

<form
    class="newsletter-signup"
    action="https://signup.propublica.org/newsletter/turing"
    method="post"
    name="newsletterSignup"
>
    <div role="region" aria-live="polite" class="newsletter-signup__feedback">
        <p class="newsletter-signup__error-message" />
    </div>
    <div
        class="newsletter-signup__input-wrap newsletter-signup__input-wrap--{borderStyle}"
    >
        <span class="icon">
            <EmailIcon />
        </span>
        <label for={inputID} class="a11y">Email Address:</label>
        <input
            class="newsletter-signup__input-text"
            type="email"
            placeholder={placeholderText}
            id={inputID}
            name="email"
            onfocus="recaptchaInit()"
            required
        />

        <div class="newsletter-signup__submit-btn-wrapper">
            <Button
                bgColor="transparent"
                iconOnly={true}
                iconSize="fill"
                shape="circle"
                textColor="var(--color-light-none)"
            >
                <ArrowRightIcon slot="iconBefore" />
                Sign Up
            </Button>
        </div>

        <input type="hidden" name="stlist" value={newsletterList} />
        <!-- <input type="hidden" name="ajax" value="true" /> -->
        <input
            type="hidden"
            name="success_location"
            value="https://www.propublica.org/forms/thankyou"
        />
        <input
            type="hidden"
            name="error_location"
            value="https://www.propublica.org/forms/error"
        />
        <input type="hidden" name="placement" value={placement} />
        <input type="hidden" name="region" value={region} />
        <input type="hidden" name="source" value={source} />
    </div>
    <div
        class="newsletter-signup__post-signup-prompt"
        role="region"
        aria-live="polite"
    >
        <!-- {% if postSignup is defined and postSignup === 'show-copy-link' %}
            <p class="newsletter-signup--in-body-promo-2__prompt-text"><strong>Thanks for signing up.</strong> If you like our stories, mind sharing this with a friend?</p>
            <textarea readonly class="-js-copy-textarea" aria-hidden="true" tabindex="-1">{{ newsletter.subscribeUrl ~ "?source=www.propublica.org&placement=share&region=" ~ entry.region|default('national') }}</textarea>
            <a href="#" class="newsletter-signup--in-body-promo-2__prompt-button | btn -js-copy-btn">Copy link</a>
        {% else %}
            <p>Thanks for signing up!</p>
        {% endif %} -->
    </div>
</form>

<NewsletterInit />
{#if newsletterSignupNumber === 1 && source !== "https://www.propublica.org/"}
    <RecaptchaInit />
{/if}

<style>.newsletter-signup__input-text {
  background-color: transparent;
  border-radius: 4px;
  -moz-appearance: none;
  -webkit-appearance: none;
  appearance: none;
  overflow: visible;
  font-family: var(--fonts-sans);
  font-size: inherit;
  line-height: 1;
  margin: 0;
  max-width: 100%;
}

.newsletter-signup__input-wrap {
  align-items: center;
  display: flex;
  opacity: 1;
  transition: opacity 0.2s;
}
.newsletter-signup__input-wrap:focus-within {
  outline: 5px auto Highlight;
  outline: 5px auto -webkit-focus-ring-color;
}

.newsletter-signup__input-text {
  border: none;
  color: inherit;
  flex-grow: 1;
  margin-left: var(--spacing-2);
  padding: 0.4em 0;
}
.newsletter-signup__input-text::placeholder {
  color: inherit;
  font-size: var(--scale-2);
}
.newsletter-signup__input-text:focus {
  outline: none;
}
.newsletter-signup__input-text:focus::placeholder {
  color: transparent;
}

.newsletter-signup__submit-btn-wrapper {
  display: flex;
  align-items: center;
}</style>
